import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
const { processAlertMessage } = require('app_custom_mufe_revamp/accessibility/accessibilityHelper');

export const giftWrap = {

    elements: {
        $cartWrapper: $('.js-cart')
    },

    selectors: {
        carousel: '.js-gift-wrap-carousel',
        cartDialog: '#cart-modal',
        checkbox: '.js-gift-wrap-checkbox',
        giftWrapHeader: '.js-gift-wrap-header',
        giftWrap: '.js-gift-wrap',
        squirrellyGiftWrap: '#giftwrap'
    },

    settings: {
        carouselParameters:
        {
            modules: [Navigation],
            slidesPerView: 2.6,
            spaceBetween: 12,
            navigation: {
                nextEl: '.js-gift-wrap-btn-next',
                prevEl: '.js-gift-wrap-btn-prev',
            },
            on: {
                slideChangeTransitionEnd(swiper) {
                    processAlertMessage('Showing gift wrap images slide ' + (swiper.realIndex + 1), true);
                }
            }
        }
    },

    state: {
        isInitialized: false,
        cartAddUrl: null,
        cartRemoveUrl: null,
        selectedWrap: null,
        swiperInstance: null,
        wrappingProducts: []
    },

    init() {
        this.initCarousel();

        if(!this.state.isInitialized){
            this.initEvents();
            this.state.cartAddUrl = this.elements.$cartWrapper.attr('data-cart-add-url');
            this.state.cartRemoveUrl = this.elements.$cartWrapper.attr('data-cart-remove-wrap');
            this.state.isInitialized = true;
        }
    },

    initEvents() {
        $(this.selectors.checkbox).on('change', this.onCheckboxChange.bind(this));
        this.elements.$cartWrapper.on('click',this.selectors.giftWrapHeader, this.toggleGiftWrapContent.bind(this));
    },

    initCarousel() {
        if(this.state.swiperInstance){
            this.state.swiperInstance.destroy();
        }
        this.state.swiperInstance = new Swiper(this.selectors.carousel, this.settings.carouselParameters);
    },

    toggleGiftWrapContent() {
        $(this.selectors.giftWrap).toggleClass('gift-wrap--expanded');
    },

    onCheckboxChange(e) {
        const input = e.target;
        const wrapID = input.value;
        this.removeProductFromCart(this.state.selectedWrap);
        this.addProductToCart(wrapID);

        this.state.selectedWrap = wrapID;
    },

    addProductToCart(wrapID) {
        $.spinner().start();
        $.ajax({
            url: this.state.cartAddUrl,
            method: 'post',
            data: {
                pid: wrapID,
                quantity: 1
            },
            success: (data) => {
                if(data.error){
                    console.warn(data.message);
                    return false;
                }
                this.updateOrderTotals(data.cart);
                $.spinner().stop();
                return true;
            }
        });
    },
    updateOrderTotals(cart) {
        const totals = cart.totals;
        const shipment = cart.shipments?.[0];
        const shippingMethod = shipment?.shippingMethods?.[0];

        const isFreeShipping =
            totals.subtotalvalue >= totals.offeredShippingMethodthreshold &&
            shippingMethod?.ID === totals.offeredShippingMethod;

        const $cartTotals = $('.js-cart-totals');
        const $shippingTotal = $cartTotals.find('.js-cart-total-shipping');

        // Update shipping
        $shippingTotal
            .toggleClass('cart-totals__value--discount', isFreeShipping)
            .text(
                isFreeShipping
                    ? cart.resources.freeShippingCostLabel
                    : shippingMethod?.shippingCost || ''
            );

        // Update totals
        $cartTotals.find('.js-cart-subtotal').text(totals.subTotal);
        $cartTotals.find('.js-cart-grand-total').text(totals.grandTotal);
        $('.js-cart-bottom .js-checkout-cart-calculator__price').text(totals.grandTotal);
    },
    removeProductFromCart() {
        $.ajax({
            url: this.state.cartRemoveUrl,
            method: 'post',
            success: () => {
                return true;
            },
            error: (data) => {
                console.warn(data.message);
                return false;
            }
        });
    },

    renderGiftWrap(cart) {
        if (cart?.wrappingProductsList) {
            this.state.wrappingProducts = cart.wrappingProductsList;
        }

        if (cart?.selectedWrap) {
            this.state.selectedWrap = cart.selectedWrap;
        }

        $(this.selectors.giftWrap).morphBy({
            id: this.selectors.squirrellyGiftWrap,
            squirrellyOptions: {
                wrappingProducts: this.state.wrappingProducts,
                selectedWrap: this.state.selectedWrap
            },
            morphDomOptions: {
                morph: true,
                childrenOnly: true
            }
        });

        this.init();
    }
};
